import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../api";
import style from "../style/Login.module.css";
import { FiEye, FiEyeOff, FiMoon, FiSun } from "react-icons/fi";

function SignupPage({ onAuthSuccess, theme = "dark", onThemeToggle }) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const navigate = useNavigate();

  //const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== repeatPassword) {
      return setError("Las contraseñas no coinciden");
    }

    setLoading(true);
    try {
      const res = await authService.signup({
        username,
        email,
        password,
      });
const newToken = res.data.token;
     
// Guardamos el token (por defecto en localStorage para que no se pierda al recargar)
    localStorage.setItem("token", newToken);

    // Informamos al estado global de App.js
    onAuthSuccess(newToken);
      // ✅ al registrarse, lo mandás a la app
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.error || "Error al registrarse");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.back}>
        <div className={style.authTopbar}>
          <button
            type="button"
            className={style.themeButton}
            onClick={onThemeToggle}
            aria-label={theme === "dark" ? "Activar tema claro" : "Activar tema oscuro"}
          >
            <FiSun className={style.themeIcon} />
            <span className={style.themeSwitchTrack}>
              <span className={style.themeSwitchThumb} />
            </span>
            <FiMoon className={style.themeIcon} />
          </button>
        </div>
        <div className={style.containerForm}>
          <img src="./imgInicio.webp" alt="imgInicio" />

          <form className={style.formCol} onSubmit={handleSubmit}>
            <p className={style.title}>Registrate para comenzar</p>

            <div className={style.containerInput}>
              <label>Usuario:</label>
              <input
                type="text"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "").slice(0, 20))
                }
                placeholder="minúsculas, sin espacios"
                autoCapitalize="none"
                required
              />
            </div>

            <div className={style.containerInput}>
              <label>Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={style.containerInput}>
              <label>Contraseña</label>

              <div className={style.passwordWrapper}>
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <span
                  className={style.eye}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>

            <div className={style.containerInput}>
              <label>Repetir contraseña</label>

              <div className={style.passwordWrapper}>
                <input
                  type={showRepeatPassword ? "text" : "password"}
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                  required
                />

                <span
                  className={style.eye}
                  onClick={() => setShowRepeatPassword((prev) => !prev)}
                >
                  {showRepeatPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>

            <div className={style.containerRegister}>
              <button
                type="submit"
                className={loading ? style.btnLoading : style.btn}
                disabled={loading}
              >
                {loading ? <div className={style.spinner}></div> : "Registrate"}
              </button>

              {error && <p className={style.errorText}>{error}</p>}

              {/* ✅ navegación real */}
              <p className={style.link} onClick={() => navigate("/login")}>
                Ya tengo una cuenta
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignupPage;
